<template>
  <div>
    <router-link
      v-bind:class="customClass ? customClass : ''"
      :to="getTo()"
      class="el-link el-link--default is-underline"
    >
      <slot />
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["to", "title", "type", "customClass"],
  methods: {
    getTo() {
      if (typeof this.to !== "string") {
        return this.to;
      }
      const client_name = this.$route.params.client_name;
      const pathMatch = this.$route.params.pathMatch;
      let route;
      if (client_name) {
        route = `/${client_name}/${this.to.replace(/^\/|\/$/g, "")}`;
      } else if (pathMatch) {
        route = `/${pathMatch}/${this.to.replace(/^\/|\/$/g, "")}`;
      } else {
        route = `/${this.to.replace(/^\/|\/$/g, "")}`;
      }

      return route;
    },
  },
};
</script>
